import { signal } from "@preact/signals-react";
import { IAxiosError } from "../../../utils";

export const errorDataLoading = signal<IAxiosError | undefined>(undefined);
export const isMobileView = signal<boolean>(false);
export const isTabletOrMobileView = signal<boolean>(false);
